export default "__VITE_ASSET__yvcWjcab__"